import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getGeneralInfo } from '../../actions';
import GeneralInfo from '../../components/Utilities/GeneralInfo';

class GeneralInfoContainer extends Component {
  componentWillMount() {
    this.props.getGeneralInfo();
  }

  render() {
    const { generalInfo } = this.props;
    if (!generalInfo) {
      return null;
    }
    const {
      APIVersion,
      APIURL,
      siteURL,
    } = generalInfo;
    return (
      <GeneralInfo APIVersion={APIVersion} APIURL={APIURL} siteURL={siteURL} />
    );
  }
}

export default connect(
  state => state,
  { getGeneralInfo }
)(GeneralInfoContainer);



// WEBPACK FOOTER //
// ./src/containers/Utilities/GeneralInfo.js